import GetUserQuery from './User';
import GetUsersQuery from './Users';

export default GetUserQuery;
export { GetUsersQuery };


// WEBPACK FOOTER //
// ./src/components/Query/Users/index.ts